// components
import Avatar from "@/components/Avatar";
import Button from "@/shared/Button";
import Link from "@/components/Link";

// assets
import styles from "@/assets/styles/components/last-used-campaign.module.scss";

interface ILastUsedCampaign {
  visitedCampaignList: Array<{ id: string | number, name: string, image: string }>;
}

const LastUsedCampaign = ({ visitedCampaignList }: ILastUsedCampaign) => {
  return (
    <div className={styles["locl-last-used-campaign"]}>
      <div className={styles["locl-last-used-campaign__title"]}>
        Recent campaign
      </div>
      <div className={styles["locl-last-used-campaign__list"]}>
        {
          visitedCampaignList.map((campaign: { id: string | number, name: string, image: string }) => (
            <Link href={`/campaign/${campaign.id}/planner`} className={styles["locl-last-used-campaign__info"]} key={campaign.id}>
              <Avatar size="small" src={campaign.image} fullName={campaign.name} />
              <div className={styles["locl-last-used-campaign__info__name"]}>
                { campaign.name }
              </div>
            </Link>
          ))
        }
      </div>
      <Button
        to="/campaigns"
        fullWidth
      >
        See all campaigns
      </Button>
    </div>
  )
}

export default LastUsedCampaign;
